import { Search } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import { useDebouncedHandler } from "../../../App/State/Hooks/useDebouncedHandler";
import { useState } from "react";

export default function CandidatesSearchInput({
  search,
  handleSearchChange,
}: {
  search: string;
  handleSearchChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const [error, setError] = useState(false);
  // Using debounced effect for delayed changes when typing in the search input
  const handleSearch = useDebouncedHandler((ev: React.ChangeEvent<HTMLInputElement>) => {
    if (!ev.target.value || ev.target.value.length >= 2) {
      handleSearchChange(ev);
      setError(false);
    }
    if (ev.target.value.length === 1) {
      setError(true);
    }
  }, 300);

  return (
    <TextField
      label="Search Candidates"
      defaultValue={search}
      onChange={handleSearch}
      placeholder="Name, email etc..."
      type="search"
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      data-test="candidates-searchbar"
      error={error}
      title={error ? "Please enter at least 2 characters" : undefined}
    />
  );
}
